import { Box, Button, styled, Theme } from "@mui/material";

export const StyledInput = styled("input")({
  width: "100%",
  border: "none",
  paddingLeft: "0.5rem",
  "&:focus": {
    outline: "none",
  },
});

export const StyledBox = styled(Box)(({ theme }: { theme: Theme }) => ({
  width: "100%",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  border: `2px solid ${theme.palette.text.primary}`,
  padding: "0.5rem",
  borderRadius: "0.5rem",
  marginTop: "1rem",
  transition: "all 0.5s",
  "&:focus-within": {
    border: `2px solid ${theme.palette.primary.main}`,
    "& svg": {
      transition: "all 0.5s",
      color: theme.palette.primary.main,
    },
  },
}));

export const StyledContainer = styled(Box)(({ theme }) => ({
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: `linear-gradient(to bottom, ${theme.palette.primary.main} 50%, transparent 50%)`,
}));

export const StyledRoot = styled(Box)(({ theme }) => ({
  width: "25%",
  padding: "2rem",
  borderRadius: "0.5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
  background: theme.palette.background.paper,
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  width: "100%",
  boxSizing: "border-box",
  marginTop: "1rem",
  borderRadius: "0.5rem",
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
}));
